<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">D/O確定</span>
      </v-card-title>

      <v-card-actions>
        <v-btn
          :disabled="!valid"
          @click="search"
          class="btn-search"
          v-permit.SHARP_DOC_SEARCH
          >{{ $t('app.buttons.search') }}</v-btn
        >
        <v-btn
          :disabled="isWarehouseTransport || hasBookingSa"
          @click="toSetPattern"
          v-permit.SHARP_DOC_PATTERN_RECONFIRMATION
          >配送パターン再確認</v-btn
        >
        <v-btn
          :disabled="hasBookingSa"
          @click="toSetFee"
          v-permit.SHARP_DOC_LOCAL_FEE_CONFIRM
          >追加費用</v-btn
        >
        <v-btn
          :disabled="selected.length != 1 || !canConfirm || hasBookingSa"
          @click="doConfirm"
          v-permit.SHARP_DOC_CONFIRM
          >D/O確定</v-btn
        >
        <v-btn
          :disabled="hasBookingSa"
          @click="doRelieveApply"
          v-permit.SHARP_DOC_RELEASE_APPLICATION
          >D/O解除申請</v-btn
        >
        <v-btn
          :disabled="hasBookingSa"
          @click="doRelieveConfirm"
          v-permit.SHARP_DOC_SEARCH_CONFIRM
          >D/O解除確認</v-btn
        >
        <v-btn
          :disabled="hasBookingSa"
          @click="drakeSharingConfirm"
          v-permit.SHARP_DOC_DRAKE_SHARING_CONFIRM
          >乗合</v-btn
        >
        <!-- <v-btn :disabled="true" @click="updateData" class="mr-2">一括登録</v-btn> -->
        <file-upload
          :businessKey="getBlNo"
          :category="'other'"
          :disabled="!canUpload"
          :domain="'bls'"
          style="margin-left: 20px"
          title="その他ファイルUp"
          v-permit.SHARP_DOC_AN_UPLOAD
        ></file-upload>
        <v-btn
          @click="doCancelDetailDownload"
          style="margin-left: 10px"
          v-permit.SHARP_DOC_CANCEL_DETAIL_DOWNLOAD
          >DO解除明細出力</v-btn
        >
        <v-btn @click="clearQuery()">検索条件クリア</v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="納入場所"
                url="warehouses/kv"
                v-model="query.sjlWarehouseId"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="invoiceNo"
                v-model="query.invoiceNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="B/L NO"
                v-model="query.blNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="D/O NO"
                v-model="query.doNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="コンテナNO"
                v-model="query.containerNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-select
                label="運送形態"
                url="transport-modes/kv"
                v-model="query.transportModeId"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                url="ports/kv"
                v-model="query.dischargePortCode"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    :label="$t('app.labels.etd')"
                    v-model="query.etdFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input
                    :min="query.etdFrom"
                    label
                    v-model="query.etdTo"
                  ></date-input>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input label="ETA" v-model="query.etaFrom"></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input
                    :min="query.etaFrom"
                    label
                    v-model="query.etaTo"
                  ></date-input>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    label="B/L発行日"
                    v-model="query.blIssueDateFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input
                    :min="query.blIssueDateFrom"
                    label
                    v-model="query.blIssueDateTo"
                  ></date-input>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="担当者ID"
                url="employees/sjl"
                v-model="query.operatorId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-select
                :items="status"
                :multiple="true"
                clearable
                item-text="value"
                item-value="value"
                label="ステータス"
                v-model="multiStatus"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                url="divisions/kv?type=BU"
                v-model="query.buId"
              />
            </v-flex>
            <v-flex md2 sm2 xs2>
              <v-checkbox
                label="請求・支払調整あり"
                v-model="query.trueResult"
              ></v-checkbox>
            </v-flex>
            <v-flex md2 sm2 xs2>
              <v-checkbox
                label="請求・支払調整なし"
                v-model="query.falseResult"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card>
      <fixed-column-wrap :data="results">
        <template slot-scope="{}">
          <v-data-table
            :disable-initial-sort="true"
            :headers="headers"
            :items="results"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[10]"
            :total-items="pagination.totalItems"
            class="inline-edit"
            item-key="id"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>{{ props.item.buCode }}:{{ props.item.buName }}</td>
              <td>{{ props.item.doNo }}</td>
              <td>{{ props.item.branchCode }}</td>
              <td v-if="!props.item.hasBookingSa">
                {{ props.item.containerNos }}
              </td>
              <td style="color: red" v-if="props.item.hasBookingSa">
                {{ props.item.containerNos }}
              </td>
              <td>{{ props.item.status }}</td>
              <td>
                {{ props.item.doConfirmStatus === '0' ? 'DO確定中' : '' }}
              </td>
              <td>
                {{
                  props.item.doConfirmStatus === '1' &&
                  props.item.status === 'DO諸掛登録済'
                    ? getDoconfirmMessageText(props.item.doConfirmMessage)
                    : ''
                }}
              </td>
              <td>{{ props.item.doConfirmDate }}</td>
              <td>
                {{
                  props.item.finallyWarehouseCode +
                    ':' +
                    props.item.finallyWarehouseName
                }}
              </td>
              <td>{{ props.item.forecastDeliveryDate }}</td>
              <td>{{ props.item.eta }}</td>
              <td>{{ props.item.etd }}</td>
              <td>{{ props.item.blNo }}</td>
              <td>{{ props.item.containerQty }}</td>
              <td>{{ props.item.blIssueDate }}</td>
              <td>{{ props.item.dischargePortName }}</td>
              <td>
                {{
                  props.item.transportModeCode == 'SEA'
                    ? props.item.shipName
                    : props.item.volNo
                }}
              </td>
              <td>{{ props.item.warehousingDate }}</td>
              <td>{{ props.item.scWarehouseName }}</td>
              <td>
                {{
                  props.item.sjlWarehouseName ||
                    props.item.scRelatedWarehouseName
                }}
              </td>
              <td>{{ props.item.customsDirectorName }}</td>
              <td>{{ props.item.deliverySupplierName }}</td>
              <td>{{ props.item.devanSupplierName }}</td>
              <td>{{ props.item.deliveryPatternName }}</td>
              <td>
                <v-icon>check</v-icon>
              </td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
    <confirm-dialog @confirmData="confirmData" ref="confirm"></confirm-dialog>
    <data-dialog @popData="updateAndSave" ref="dataDialog"></data-dialog>
    <message-alert ref="message"></message-alert>
    <cancel-confirm-dialog
      :deliveryOrder="selected[0]"
      @refresh="load"
      ref="cancelDialog"
    ></cancel-confirm-dialog>
    <drake-sharing-dialog ref="drakeSharingDialog"></drake-sharing-dialog>
    <confirm-3-dialog
      ref="confirm3"
      @confirm="confirmCancel"
      @reject="rejectCancel"
      @cancel="cancelCancel"
    ></confirm-3-dialog>
  </v-container>
</template>

<script>
import ConfirmDialog from './ConfirmDialog'
import DataDialog from './DataDialog'
import CancelConfirmDialog from './CancelConfirmDialog'
import drakeSharingDialog from './DrakeSharingDialog'
import Confirm3Dialog from '../../components/Confirm3Dialog'

export default {
  components: {
    ConfirmDialog,
    DataDialog,
    CancelConfirmDialog,
    drakeSharingDialog,
    Confirm3Dialog,
  },
  methods: {
    clearQuery() {
      this.$clearQuery()
      this.multiStatus = []
    },
    confirmCancel() {
      this.$router.push({
        path: '/B1901',
        query: {
          id: this.selected[0].doShipmentId,
          status: 'CANCEL',
          type: 'CANCEL',
        },
      })
    },
    rejectCancel() {
      this.$router.push({
        path: '/B1901',
        query: {
          id: this.selected[0].doShipmentId,
          status: 'CANCEL',
          type: 'REMOVE',
        },
      })
    },
    cancelCancel() {
      this.load()
    },
    calcFee() {
      this.$router.push({
        path: '/B0802',
        query: {
          id: this.selected[0].id,
        },
      })
    },
    toSetPattern() {
      if (this.canOperate()) {
        this.$router.push({
          path: '/B0801',
          query: {
            id: this.selected[0].id,
          },
        })
      }
    },
    toSetFee() {
      if (this.canOperate()) {
        this.$router.push({
          name: 'B0802',
          query: {
            id: this.selected[0].id,
          },
        })
      }
    },
    doCancelDetailDownload() {
      this.$http
        .get('/status-history/cancel-apply', {
          params: {
            ...this.$pageable(),
            size: 999999,
            page: 0,
          },
        })
        .then((res) => {
          let content = res.data.content.map((c) => {
            return {
              ...c,
              q2: '検収されていない',
              q3: 'はい',
            }
          })

          this.$exportTable(
            content,
            [
              'doNo',
              'operationDate',
              'partnerName',
              'cancelReason',
              'q2',
              'q3',
            ],
            [
              'ＤＯ番号',
              'DO解除申請の日期',
              '海外取引先名',
              '解除理由Ｑ１',
              'Q2',
              'Q3',
            ],
            'DO解除明細'
          )
        })
    },
    load() {
      // if (this.trueResult) {
      //   this.query.adjusted = true
      // } else if (this.falseResult) {
      //   this.query.adjusted = false
      // } else {
      //   this.query.adjusted = null
      // }
      this.query.moduleCode = 'F800'
      this.autoload = true
      this.$http
        .get('/delivery-orders', {
          params: {
            ...this.query,
            ...this.$pageable(),
          },
        })
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
    },
    updateData() {
      this.$refs.dataDialog.popup()
    },
    updateAndSave(e) {
      this.selected.forEach((item) => {
        item.sjlWarehouseId = e.sjlWarehouseId
        item.finallyWarehouseId = e.finallyWarehouseId
        item.forecastAcceptanceTime = e.forecastAcceptanceTime
      })
      Promise.all(
        this.selected.map((s) => {
          return this.$http.put(`/delivery-orders/${s.id}`, s)
        })
      ).then(() => this.load())
    },
    doConfirm() {
      if (
        this.selected[0].status == '納入指示済' ||
        this.selected[0].status == '受入確認済'
      ) {
        this.$message('', this.$t('B0800.messages.noPattern')) //请先进行业者确认:'先に配送パターンのご確認を願います。'
        return
      }
      if (this.selected[0].status == 'DO業者確認済') {
        this.$message('', this.$t('B0800.messages.noChargeConfirm')) //请先进行费用确认:先にDO費用のご確認を願います。
        return
      }
      if (this.selected[0].status == 'DO確定済') {
        this.$message('', this.$t('B0800.messages.doConfirmed')) //已经DO确认:該当DOが確認済です。
        return
      }
      if (this.selected[0].status == 'DO解除承認待ち') {
        this.$message('', this.$t('B0800.messages.doRelieving')) //DO解除中:該当DOが解除申請中のため、DO確定できません。
        return
      }
      // if (this.selected[0].status == 'DO解除済') {
      //   this.$message('', 'DO已解除')
      //   return
      // }
      if (!this.doNoNotNull()) {
        this.$message('', this.$t('B0800.messages.doNoEmpty')) //DO.NOが無いと、DO確定できません。
        return
      }
      if (this.canOperate() && this.canConfirm) {
        this.confirmData()
      }
    },
    getDoconfirmMessageText(messageCode) {
      if (messageCode === null || messageCode === '') {
        return null
      }
      let messageDic = {
        DO_HAS_CONFIRMED: this.$t('B0800.messages.doConfirmed'),
        BL_NO_DUPLICATE: this.$t('B0800.messages.blNoDuplicate'),
        CCFEE_QTY_NOT_RIGHT:
          'CC.FEEが未計算、またはfreight調整後金額で計算されていないので、DO確定できません。諸掛費用を再計算してください。',
        EXCHANGE_RATE_NOT_FOUND: this.$t('B0800.messages.exchangeRateNotFound'),
        MISS_PRODUCT: this.$t('B0800.messages.productNotFound'),
        NO_WAREHOUSE_MANAGER: this.$t('B0800.messages.noWhsManager'),
        PRICE_MUST_VALID: this.$t('bizException.PRICE_MUST_VALID_GROUP'),
        PRICE_MUST_EQUAL: this.$t('bizException.PRICE_MUST_VALID_GROUP'),
        NGW_MUST_VALID: this.$t('bizException.NGW_MUST_VALID_GROUP'),
        TOTAL_GROSS_WEIGHT_MUST_EQUAL: this.$t(
          'bizException.NGW_MUST_VALID_GROUP'
        ),
        TOTAL_VOLUME_MUST_EQUAL: this.$t('bizException.NGW_MUST_VALID_GROUP'),
        CW6000_MUST_EQUAL: this.$t('bizException.NGW_MUST_VALID_GROUP'),
        TOTAL_GROSS_WEIGHT_OF_UNPAID_MUST_EQUAL: this.$t(
          'bizException.NGW_MUST_VALID_GROUP'
        ),
        TOTAL_VOLUME_OF_UNPAID_MUST_EQUAL: this.$t(
          'bizException.NGW_MUST_VALID_GROUP'
        ),
        CW6000_OF_UNPAID_MUST_EQUAL: this.$t(
          'bizException.NGW_MUST_VALID_GROUP'
        ),
        PRICE_OF_UNPAID_MUST_EQUAL: this.$t(
          'bizException.PRICE_MUST_VALID_GROUP'
        ),
        CW283_MUST_EQUAL: this.$t('bizException.NGW_MUST_VALID_GROUP'),
        EIAJ_AMOUNT_ILLEGAL:
          '按分結果はマイナスチャージ項目があるため、DO確定ができません',
        CURRENCY_CODE_NOT_EXISTS:
          '通貨が存在していませんので、保存できません。',
        INVALID_FORECAST_DATE: '納入予定日が前月日付のため、確定できません。',
      }

      return messageDic[messageCode] || this.$t('app.system.error')
    },
    catch(res) {
      if (res.response.status === 500) {
        if (res.response.data.message == 'DO_HAS_CONFIRMED') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B0800.messages.doConfirmed')
          )
        } else if (res.response.data.message == 'BL_NO_DUPLICATE') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B0800.messages.blNoDuplicate')
          )
        } else if (res.response.data.message == 'CCFEE_QTY_NOT_RIGHT') {
          this.$message(
            this.$t('app.messages.errors.title'),
            'CC.FEEが未計算、またはfreight調整後金額で計算されていないので、DO確定できません。諸掛費用を再計算してください。'
          )
        } else if (res.response.data.message == 'EXCHANGE_RATE_NOT_FOUND') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B0800.messages.exchangeRateNotFound')
          )
        } else if (res.response.data.message == 'MISS_PRODUCT') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B0800.messages.productNotFound')
          ) //品番缺少品种:'品番は品種情報がない'
        } else if (res.response.data.message == 'NO_WAREHOUSE_MANAGER') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('B0800.messages.noWhsManager')
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (res.response.data.message == 'PRICE_MUST_VALID') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('bizException.PRICE_MUST_VALID_GROUP')
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (res.response.data.message == 'PRICE_MUST_EQUAL') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('bizException.PRICE_MUST_VALID_GROUP')
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (res.response.data.message == 'NGW_MUST_VALID') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('bizException.NGW_MUST_VALID_GROUP')
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (
          res.response.data.message == 'TOTAL_GROSS_WEIGHT_MUST_EQUAL'
        ) {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('bizException.NGW_MUST_VALID_GROUP')
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (res.response.data.message == 'TOTAL_VOLUME_MUST_EQUAL') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('bizException.NGW_MUST_VALID_GROUP')
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (res.response.data.message == 'CW6000_MUST_EQUAL') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('bizException.NGW_MUST_VALID_GROUP')
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (
          res.response.data.message == 'TOTAL_GROSS_WEIGHT_OF_UNPAID_MUST_EQUAL'
        ) {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('bizException.NGW_MUST_VALID_GROUP')
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (
          res.response.data.message == 'TOTAL_VOLUME_OF_UNPAID_MUST_EQUAL'
        ) {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('bizException.NGW_MUST_VALID_GROUP')
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (res.response.data.message == 'CW6000_OF_UNPAID_MUST_EQUAL') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('bizException.NGW_MUST_VALID_GROUP')
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (res.response.data.message == 'PRICE_OF_UNPAID_MUST_EQUAL') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('bizException.PRICE_MUST_VALID_GROUP')
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (res.response.data.message == 'CW283_MUST_EQUAL') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('bizException.NGW_MUST_VALID_GROUP')
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (res.response.data.message == 'EIAJ_AMOUNT_ILLEGAL') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '按分結果はマイナスチャージ項目があるため、DO確定ができません'
          ) //'送信先は存在しない、担当者設定してから再送信してください。'
        } else if (res.response.data.message == 'CURRENCY_CODE_NOT_EXISTS') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '通貨が存在していませんので、保存できません。'
          )
        } else if (res.response.data.message == 'INVALID_FORECAST_DATE') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '納入予定日が前月日付のため、確定できません。'
          )
        } else {
          this.$message('', this.$t('app.system.error'))
          //'未知エラーが発生しましたので、IT担当に問い合わせください。'
          //`system error, module:${this.$route.path}`
        }
      }
    },
    checkConfirmStatus(id, count) {
      this.$http
        .get(`delivery-orders/${id}/is-confirm-finish`)
        .then((res) => {
          if (res.data) {
            this.load()
            this.$message('', this.$t('B0800.messages.doSuccessConfirm')) //'D/O確定完了'
            return
          } else {
            this.checkConfirmStatus(id)
          }
        })
        .catch((err) => {
          this.checkConfirmStatus(id)
        })
    },
    confirmData() {
      this.$http
        .get(`/shipping-advices/${this.selected[0].id}/valid-handle-status`)
        .then((res) => {
          if (!res.data) {
            this.$refs.confirm3.popup({
              title: '',
              content:
                '当該SAに対して、SAPよりCANCELデータを受信しました。SHIPPER側に確認の上、処理方法を選択してください。',
              action: '登録済みSAの取消し',
              rejectAction: 'CANCELデータを削除',
              cancelAction: 'キャンセル',
            })
          } else {
            this.doConfirmData()
          }
        })
    },
    doConfirmData() {
      var id = this.selected[0].id
      this.$http
        .get(`/delivery-orders/${id}/isSaHasFreightCharge`)
        .then((res) => {
          if (res.data == 0) {
            Promise.all(
              this.selected.map((s) => {
                return this.$http
                  .put(`/delivery-orders/${s.id}/confirm?version=${s.version}`)
                  .then((res) => {
                    setTimeout(() => {
                      this.checkConfirmStatus(id)
                    }, 1000)
                    // if (res.data === 'DELAY') {
                    //   setTimeout(() => {
                    //     this.checkEiajCount(id)
                    //   }, 1000)
                    // } else {
                    //   this.load()
                    //   this.$message(
                    //     '',
                    //     this.$t('B0800.messages.doSuccessConfirm')
                    //   ) //'D/O確定完了'
                    // }
                  })
                  .catch((res) => {
                    this.$showError(res)
                  })
              })
            ).catch((res) => {
              this.$showError(res)
            })
            this.selected = []
          } else if (res.data == 1) {
            this.$message('', 'フレイト確認未処理です') //フレイト費用を計算しないと、DO確定できません。
          } else {
            this.$message('', this.$t('B0800.messages.noFreightCharge')) //フレイト費用を計算しないと、DO確定できません。
          }
        })
    },
    doRelieveApply() {
      if (this.canOperate()) {
        if (this.selected[0].status == 'DO確定済') {
          this.$refs.cancelDialog.popup()
        } else {
          this.$message('', this.$t('B0800.messages.unableRelieve')) //未確定のDOは解除できません。
        }
      }
    },
    doRelieveConfirm() {
      if (this.canOperate() && this.canConfirmCancel()) {
        Promise.all(
          this.selected.map((s) => {
            return this.$http.put(
              `/delivery-orders/${s.id}/cancel-confirm?version=${s.version}`
            )
          })
        )
          .then(() => {
            this.load()
            this.$message('', this.$t('B0800.messages.relieveSuccess')) //DO解除済
          })
          .catch((res) => {
            this.$showError(res)
          })
      }
    },

    drakeSharingConfirm() {
      if (this.selected.length > 0) {
        this.$refs.drakeSharingDialog.popup(this.selected.map((s) => s.id))
      } else {
        this.$message('', '乗合不可') //未確定のDOは解除できません。
      }
    },
    initMultiStatus() {
      this.multiStatus =
        this.query.multiStatusString && this.query.multiStatusString.split(',')
    },
    search() {
      this.query.multiStatusString =
        this.multiStatus && this.multiStatus.join(',')
      this.$storeParams()
      this.pagination.page = 0
      this.selected = []
      this.load()
    },
    back() {
      this.$router.go(-1)
    },
    canOperate() {
      if (this.selected.length != 1) {
        this.$message('', this.$t('B0800.messages.select_one')) //'一つのD/Oデータをチェックしてください。'
        return false
      }
      return true
    },
    doNoNotNull() {
      //TODO DO確定的条件
      if (this.selected[0].doNo == null || this.selected[0].doNo == '') {
        return false
      }
      return true
    },
    containerNos(item) {
      return item.packages
        .map((p) => p.containerNo)
        .reduce((a, b) => {
          if (a.indexOf(b) == -1) {
            a.push(b)
          }
          return a
        }, [])
        .join(',')
    },
    canConfirmCancel() {
      if (
        this.selected
          .map((s) => s.status)
          .filter((d) => {
            return d == 'DO解除承認待ち'
          }).length < this.selected.length
      ) {
        this.$message('', this.$t('B0800.messages.unableRelieveConfirm')) //DO解除申請をしないと、DO解除確認できません
        return false
      }
      return true
    },
  },
  computed: {
    isWarehouseTransport() {
      return (
        this.selected.length === 1 &&
        this.selected[0].specialCode === 'WAREHOUSE_TRANSPORT'
      )
    },
    hasBookingSa() {
      return this.selected.filter((d) => d.hasBookingSa).length > 0
    },
    hasPartSku() {
      return this.selected[0].packages.filter((p) => p.skuType === '部品')
        .length > 0
        ? true
        : false
    },
    visiableHeaders() {
      return this.headers.filter((p) => !p.hide)
    },
    canCancelConfirm() {
      return this.selected
        .map((s) => s.status)
        .filter((d) => {
          return d == 'DO確定済'
        }).length < this.selected.length
        ? false
        : true
    },

    canAdd() {
      return (
        this.selected.filter((s) => {
          return (
            s.forecastDeliveryDate != null && s.forecastAcceptanceTime != null
          )
        }).length < this.selected.length
      )
    },
    canConfirm() {
      return this.selected
        .map((s) => s.status)
        .filter((d) => {
          return d == 'DO諸掛登録済'
        }).length < this.selected.length
        ? false
        : true
    },
    canUpload() {
      return this.selected && this.selected.length == 1
    },
    getBlNo() {
      return this.selected && this.selected.length && this.selected[0].blNo
    },
  },
  mounted() {
    this.$clearParams()
    this.$loadParams()
    this.initMultiStatus()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
  data: () => ({
    valid: false,
    results: [],
    loading: false,
    trueResult: null,
    falseResult: null,
    order: {},
    orders: [],
    selected: [],
    query: {
      moduleCode: 'F800',
    },
    multiStatus: [],
    falseResult: null,
    trueResult: null,
    pagination: {
      page: 1,
    },
    adjustedValue: [
      {
        text: '請求',
        value: 'request',
      },
      {
        text: '支払',
        value: 'payment',
      },
    ],
    status: [
      {
        key: 1,
        value: 'DO諸掛登録済',
        sortable: false,
      },
      {
        key: 2,
        value: 'DO解除済',
        sortable: false,
      },
      {
        key: 3,
        value: '納入指示済',
        sortable: false,
      },
      {
        key: 4,
        value: '受入確認済',
        sortable: false,
      },
      {
        key: 5,
        value: 'DO解除承認待ち',
        sortable: false,
      },
      {
        key: 6,
        value: 'DO確定済',
        sortable: false,
      },
      {
        key: 7,
        value: 'DO業者確認済',
        sortable: false,
      },
    ],
    headers: [
      {
        text: '事業本部',
        value: 'buName',
        sortable: false,
        class: 'fixed',
      },
      {
        text: 'D/O NO',
        value: 'doNo',
        sortable: false,
        class: 'fixed',
      },
      {
        text: '枝番',
        value: 'branchCode',
        sortable: false,
        class: 'fixed',
      },
      {
        text: 'コンテナNO',
        value: 'containerNo',
        sortable: false,
        class: 'fixed',
      },
      {
        text: 'ステータス',
        value: 'status',
        sortable: true,
        class: 'fixed',
      },
      {
        text: 'DO確定進捗',
        value: 'doConfirmStatus',
        sortable: true,
        class: 'fixed',
      },
      {
        text: 'DO確定失敗原因',
        value: 'doConfirmMessage',
        sortable: true,
        class: 'fixed',
      },
      {
        text: 'DO確定日',
        value: 'doConfirmDate',
        sortable: false,
      },
      {
        text: '最終納入場所',
        value: 'finallyWarehouseId',
        sortable: true,
      },
      {
        text: '受入予定日時間',
        value: 'forecastDeliveryDate',
        sortable: false,
      },
      {
        text: 'ETA',
        value: 'eta',
        sortable: false,
      },
      {
        text: 'ETD',
        value: 'etd',
        sortable: false,
      },
      {
        text: 'B/L NO',
        value: 'blNo',
        sortable: false,
      },
      {
        text: 'BLコンテナ本数',
        value: 'containerQty',
        sortable: false,
      },
      {
        text: 'B/L発行日',
        value: 'blIssueDate',
        sortable: false,
      },
      {
        text: '陸揚港',
        value: 'landingPort',
        sortable: false,
      },
      {
        text: '本船名',
        value: 'vessel',
        sortable: false,
      },
      {
        text: '納入指示日',
        value: 'forecastDeliveryDate',
        sortable: false,
      },
      {
        text: 'SC納入場所',
        value: 'warehouseName',
        sortable: false,
      },
      {
        text: 'SJL納入場所',
        value: 'sjlWarehouseId',
        sortable: false,
      },

      {
        text: '通関業者',
        value: 'customsDirectorName',
        sortable: false,
      },
      {
        text: '配送業者（代表）',
        value: 'deliveryCompany1Name',
        sortable: false,
      },
      {
        text: 'デバン業者',
        value: 'devanTraderName',
        sortable: false,
      },
      {
        text: '配送パターン',
        value: 'deliveryPatternName',
        sortable: false,
      },
      {
        text: 'EIAJ集約',
        value: 'deliveryPatternName',
        sortable: false,
      },
    ],
    errors: {
      SHIPMENT_HAS_CHANGED:
        '当該データのステータスは更新されたため、画面更新してからもう一度お試してください。',
    },
  }),
}
</script>
